import { withTranslation } from "next-i18next";
import PropTypes from "prop-types";
import classNames from "classnames";
import Button from "../Button";

function CloseButton({
  trackingName = "",
  variant = "ghost-dark",
  size,
  className,
  title,
  t,
  ...other
}) {
  return (
    <Button
      trackingName={trackingName}
      title={title || t("common:close")}
      leftIconName="close"
      variant={variant}
      size={size}
      className={classNames("close", className)}
      {...other}
    />
  );
}

CloseButton.propTypes = {
  variant: PropTypes.string,
  trackingName: PropTypes.string,
};

export default withTranslation("common")(CloseButton);
